import React from 'react';
import QueryForm from './QueryForm';
import NavigationBar from '../NavigationBar';
import SideNavigation from "../SideNavigation";

const ReportPanel = () => {
    return(
        <div>
            <SideNavigation current="reports"/>
            <div className="page-order">
                <NavigationBar/>
                <QueryForm isWidget={false} rid={0}/>
            </div>
        </div>
    );
};

export default ReportPanel;
